import { on } from '../modules/_fn';

/* ---------------------------------------- swiper */
function buildSwiperCarousel(swiperTarget) {
	if ($(swiperTarget)) {
		var swiperConfig = {
			speed: 300,
			initialSlide: 0,
			slidesPerView: 'auto',
			spaceBetween: 8,
			centeredSlides: true,
			watchSlidesProgress: true,
			pagination: {
				el: swiperTarget + ' .swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
			navigation: {
				nextEl: swiperTarget + ' .swiper-button-next',
				prevEl: swiperTarget + ' .swiper-button-prev',
			},
			breakpoints: {
				640: {
					initialSlide: 1,
					slidesPerView: 'auto',
					spaceBetween: 20,
				},
				1024: {
					initialSlide: 1,
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},
		};

		if (typeof Swiper !== undefined) {
			new Swiper(swiperTarget + ' .swiper-container', swiperConfig);
		}
	}
}

on(window, 'load', buildSwiperCarousel('.sec-combos'));
/* ---------------------------------------- swiper */